const NAVIGATION_SECTION = {
  myHub: {
    value: 'myHub',
    label: 'My Hub',
  },
  favorites: {
    value: 'favorites',
    label: 'Favorites',
  },
  workspace: {
    value: 'workspace',
    label: 'Workspace',
  },
  admin: {
    value: 'admin',
    label: 'Admin',
  },
};

export { NAVIGATION_SECTION };
